// @ts-nocheck
import styled from "styled-components";

interface ContainerProps {
  $backgroundColor?: string,
  $noBorder?: boolean
}

export const Container = styled.div<ContainerProps>`
cursor: pointer;
margin: 1rem 0;
background-color: ${props => 
  (props.$backgroundColor === "main" ? 'var(--background-main)' : 
  (props.$backgroundColor === "success" ? 'var(--background-success)' : 
  'var(--background-alternate)'))|| 'transparent'};
  padding: ${props => props.$backgroundColor ? '1rem' : '0'};
  border-radius: ${props => props.$backgroundColor ? '16px' : '0'};
`

export const TitleContainer = styled.div<ContainerProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.875rem 0 1.25rem;
  border-bottom: ${props => props.$noBorder ? 'none !important' : 'solid 1px rgba(0, 0, 0, 0.2)'};
`

export const Title = styled.div`
  font-size: 1.25rem;
  line-height: 1.3;
  font-weight: 600;
  color: #000;
  opacity: 60%;
  max-width: 85%;
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
`

export const ArrowIconContainer = styled.div`
  margin-right: 1rem;
`

export const ContentContainer = styled.div`
  margin-top: 1rem;
`

export const IconImage = styled.img`
width: 1.5rem;
height: 1.5rem;
`

export const PreviewContainer = styled.div`
  line-height: 1.5em;
  height: 3em;
  overflow: hidden;
  text-overflow: ellipsis;
`
